.snapshotCard {
  padding: 0;
  cursor: pointer;
  outline: 0;
  position: relative;
}

.snapshotCard:hover {
  border: 1px solid var(--primary-hover);
  outline: 0.5px solid var(--primary-hover);
}

.snapshotCardWrapper {
  position: relative;
}

.snapshotCardHeader {
  padding: 1.25rem;
  border-radius: 0.75rem;
  border-bottom-right-radius: 0.75rem;
  background-color: var(--static-background-standard);
  position: relative;
}

.snapshotCardHeader h3 {
  margin-bottom: 0.4rem;
}

.snapshotCardBackground {
  position: absolute;
  right: 0;
  bottom: 0;
}

.snapshotCardBackground path {
  fill: rgb(0, 0, 0, 0.04)
}

.snapshotCardContent {
  margin-top: -0.75rem;
  padding: 2rem 1.25rem 1.25rem;
  background: var(--static-background-weak);
  border-bottom-left-radius: 0.75rem;
  border-bottom-right-radius: 0.75rem;
}

.activeSnapshotCard {
  border: 1px solid var(--primary-enabled);
  outline: 0.5px solid var(--primary-enabled);
}

.activeSnapshotCard .snapshotCardBackground path {
  fill: var(--selectable-selected);
}

.snapshotCardDetailToggle {
  position: absolute;
  top: 0.75rem;
  right: 1.5rem;
  cursor: pointer;
  background-color: transparent;
  border: none;
  padding: 0.5rem;
  z-index: 2;
  color: var(--primary-enabled);
}

.snapshotCardDetailToggle:hover {
  color: var(--primary-enabled);
}

.snapshotCardDetailCloseButton {
  composes: snapshotCardDetailToggle;
  color: var(--static-text-standard);
}

.snapshotCardDetail {
  composes: snapshotCard activeSnapshotCard;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  box-shadow: var(--box-shadow);
  z-index: 10;
  overflow: hidden;
}

.snapshotCardDetailHeader {
  padding: 0.75rem 1.5rem;
  position: relative;
}

.snapshotCardDetailHeader h3 {
  margin-bottom: 0.4rem;
}

.snapshotCardDetailDate {
  color: var(--static-text-weak);
  font-size: var(--fs-small);
  font-style: normal;
  font-weight: normal;
  line-height: 1rem;
  flex-shrink: 0;
}

.snapshotCardDetailContent {
  padding: 0.75rem 1.25rem;
  background: var(--static-background-standard);
  border-bottom: 1px solid var(--static-divider-standard);
}

.snapshotCardDetailFooter {
  padding: 0.75rem 1.5rem;
  position: relative;
  background: var(--static-background-weak);
}

.snapshotCardDetailSectionButton {
  font-size: var(--fs-small);
  line-height: 1.25rem;
  display: flex;
  justify-content: start;
  gap: 0.3125rem;
  padding: 0.25rem 0;
  cursor: pointer;
  background-color: transparent;
  border: none;
  width: 100%;
  align-items: center;
  color: var(--static-text-standard);
}

.featuredSnapshotCardDetailSectionButton {
  font-weight: 500;
  color: var(--primary-enabled);
}

.snapshotCardDetailSectionButtonValue {
  margin-left: auto;
  color: var(--static-text-standard);
}

.featuredSnapshotCardDetailSectionButton .snapshotCardDetailSectionButtonValue {
  color: var(--primary-enabled);
}

.snapshotCardDetailSectionButtonIcon {
  transition: transform 100ms;
}

.activeSnapshotCardDetailSectionButtonIcon {
  transform: rotate(90deg);
}

.snapshotCardDetailSectionList {
  padding: 0.25rem 0 0 0.625rem;
}

.snapshotCardDetailListItem {
  color: var(--static-text-weak);
}

.snapshotCardDetailListItem span {
  color: var(--static-text-weak);
}

.snapshotCardDetailFooterItem {
  font-weight: 500;
}